import { render, staticRenderFns } from "./manage-groups-activities.vue?vue&type=template&id=fa432058&scoped=true"
import script from "./manage-groups-activities.vue?vue&type=script&lang=js"
export * from "./manage-groups-activities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa432058",
  null
  
)

export default component.exports